module.exports = __webpack_public_path__ + "static/icon_score-298cc031d86fa7880b857e5689585177.png";